import styled from 'styled-components';
import { TableBodyItem } from '../../Table.styles';
import { Text14Light } from '../../../utils/Text/Text.styles';

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  padding-right: 1.6rem;
  position: relative;
`;

export const TextLink = styled.a`
  color: #1672ba;
  text-decoration-line: underline;
  user-select: none;
  cursor: pointer;
  font-size: 1.5rem;
  font-weight: 300;
`;

export const LastColumnItem = styled(TableBodyItem)`
  justify-content: flex-end;
`;

export const TooltipContainer = styled.div`
  border-radius: 12px;
  border: 1px solid #badaf7;
  background: #d8eaf9;
  padding: 1.2rem;
  position: absolute;
  width: 24rem;
  right: 2rem;
  top: 2.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  z-index: 1000;
`;

export const TooltipText = styled(Text14Light)`
  opacity: 0.8;
  line-height: 20px;
  letter-spacing: -0.408px;
`;
